import React, {Component} from 'react';
import CashOutStepFirst from './CashOutStepFirst';
import CashOutStepSecond from './CashOutStepSecond';

export default class CashOutUserModalBody extends Component {

    render() {
        const {
            orderList,
            inputProps,
            handleSmsCode,
            loadMoreOrders,
            is_email_confirmed,
            handleOnChangeSimple,
        } = this.props;
        const {
            type, code, amount, fio, inn, field_errors,
            card_number, confirmData, comission, step,
            willWithdraw, ndfl, user_type, payment_type,
            minNdflText,
        } = inputProps;

        if(type === 'success') {
            return  <div>
                        <label style={{display:'block'}}>Операция ждет подтверждения администратора</label>
                    </div>
        }

        if(type === 'error') {
            return  <div>
                        <label style={{display:'block'}}>Ошибка!</label>
                        {
                            confirmData && confirmData.non_field_errors ?
                            <div style={{display:'block'}}>{confirmData.non_field_errors}</div>
                            : null
                        }
                    </div>
        }

        return (
                step === 1
                ?
                <CashOutStepFirst
                    fio={fio}
                    inn={inn}
                    ndfl={ndfl}
                    amount={amount}
                    orderList={orderList}
                    comission={comission}
                    user_type={user_type}
                    minNdflText={minNdflText}
                    card_number={card_number}
                    payment_type={payment_type}
                    field_errors={field_errors}
                    willWithdraw={willWithdraw}
                    loadMoreOrders={loadMoreOrders}
                    is_email_confirmed={is_email_confirmed}
                    handleOnChangeSimple={handleOnChangeSimple}
                    />
                :
                <CashOutStepSecond
                    code={code}
                    comission={comission}
                    confirmData={confirmData}
                    field_errors={field_errors}
                    willWithdraw={willWithdraw}
                    handleSmsCode={handleSmsCode}
                    />
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Profile/Balance/CashOutUserModalBody.js